/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Displays a green dot if the statement has `earnings === null`.
 * @param Props must contain a `cell.value` mapped to trqkStatementView.earnings
 */
export function StatementStatusCell<D extends object>({
    cell,
}: Props<D>): JSX.Element | null {
    const value = cell?.value as Maybe<number>;

    if (value === null) {
        return <div className="bg-secondary-500 h-2 w-2 rounded-full" />;
    }

    return null;
}
